import React from 'react'
import SegmentInspector from './SegmentInspector'

export interface MainSegmentInspectorProps {
  segment: any
  segmentKey: string
  onChange: (data: any) => void
  onNavigateToElement?: (element: any, elementIndex: number) => void
  readonly?: boolean
}

const MainSegmentInspector = React.memo<MainSegmentInspectorProps>(
  ({ segment, segmentKey, onChange, onNavigateToElement, readonly = false }) => {
    // Use SegmentInspector with main segment context (no loop index)
    return (
      <SegmentInspector
        segment={segment}
        segmentIndex={0} // Main segment is always at index 0
        loopIndex={-1} // -1 indicates this is a main segment, not in a loop
        onChange={onChange}
        onNavigateToElement={onNavigateToElement}
        readonly={readonly}
      />
    )
  }
)

MainSegmentInspector.displayName = 'MainSegmentInspector'

export default MainSegmentInspector
